export type RecoveryChannel = {
  id: string
  name: string
  iconUrl?: string
}

export const recoveryChannels: RecoveryChannel[] = [
  { id: 'manymoons', name: 'Manymoons', iconUrl: 'https://cdn.magicpatterns.com/uploads/1H17upTEPhdYPo8CxCujBt/M_manymoons.svg' },
  { id: 'depop', name: 'Depop', iconUrl: 'https://cdn.magicpatterns.com/uploads/fG9XmMcsDQikNiC1uba9MJ/dopop.svg' },
  { id: 'ebay', name: 'eBay', iconUrl: 'https://cdn.magicpatterns.com/uploads/7ctVShw3HBQcunanqiLN75/ebay.svg' },
  { id: 'mercari', name: 'Mercari', iconUrl: 'https://cdn.magicpatterns.com/uploads/cisCD3tYpjAhP5v7GoDZxD/mercari.svg' },
  { id: 'poshmark', name: 'Poshmark', iconUrl: 'https://cdn.magicpatterns.com/uploads/n5jkPZQbazKpxu5cMnVHR4/poshmark.svg' },
  { id: 'prive', name: 'Privé', iconUrl: 'https://cdn.magicpatterns.com/uploads/fHmVmW1X2zeRckQHVqfLBY/prive.svg' },
  { id: 'tiktok', name: 'TikTok Live', iconUrl: 'https://cdn.magicpatterns.com/uploads/9zCU7ZyrDgBa4HCXG66eUn/tiktok.svg' },
  { id: 'vestiaire', name: 'Vestiaire', iconUrl: 'https://cdn.magicpatterns.com/uploads/tLawC51vDdyw6q2RLyZ5Bc/vestiaire.svg' },
  { id: 'vinted', name: 'Vinted', iconUrl: 'https://cdn.magicpatterns.com/uploads/6n8bfmq2ixHXbjbeTaLCJz/vinted.svg' },
  { id: 'whatnot', name: 'Whatnot', iconUrl: 'https://cdn.magicpatterns.com/uploads/tKhY3ZxiXEuMX34dV7VA57/whatnot.svg' },
]

export type RecoveryRules = {
  channels: string[]
  indexPrice: number
  horizonMonths: number
  liveSellingAfterMonth: number
}

// The account-level defaults set in Settings. Every submission inherits these
// until someone overrides them for that specific upload.
export const defaultRecoveryRules: RecoveryRules = {
  channels: ['manymoons', 'ebay', 'whatnot'],
  indexPrice: 50,
  horizonMonths: 9,
  liveSellingAfterMonth: 3,
}

export function rulesMatchDefaults(rules: RecoveryRules) {
  return (
    rules.indexPrice === defaultRecoveryRules.indexPrice &&
    rules.horizonMonths === defaultRecoveryRules.horizonMonths &&
    rules.liveSellingAfterMonth === defaultRecoveryRules.liveSellingAfterMonth &&
    rules.channels.length === defaultRecoveryRules.channels.length &&
    rules.channels.every((id) => defaultRecoveryRules.channels.includes(id))
  )
}

export function summarizeRules(rules: RecoveryRules) {
  return `${rules.channels.length} ${rules.channels.length === 1 ? 'channel' : 'channels'} · ${rules.indexPrice}% MSRP · ${rules.horizonMonths} mo`
}
